export default __webpack_public_path__ + "static/media/wep9.c551cef6.jpg";